// Environment Utils

export function isStage() {
  const href = window.location.href
  // stportal also covers devstportal and demostportal
  return (
    href.includes('stportal.victorops') ||
    href.includes('stportal.vo') ||
    Boolean(href.match(/stage\.mr\-[\d]+\.[a-z\-]+\.victorops-sandbox/))
  )
}

export function isProduction() {
  const href = window.location.href
  return (
    (href.includes('portal.victorops') ||
      href.includes('portal.vo.dev') ||
      Boolean(
        href.match(/production\.mr\-[\d]+\.[a-z\-]+\.victorops-sandbox/)
      )) &&
    !isStage() &&
    !isAWSPlayground()
  )
}

export function isAWSProduction() {
  const href = window.location.href
  return href.includes('production.victorops')
}

export function isAWSStage() {
  const href = window.location.href
  return href.includes('staging.victorops')
}

export function isAWSPlayground() {
  const href = window.location.href
  return (
    href.includes('playground.victorops') ||
    href.includes('plportal.victorops') ||
    href.includes('portal.vo.cyclops') ||
    href.includes('app-play1.dev')
  )
}
